<template>
  <div>
    <a-modal v-model="modalVisible" :destroy-on-close="true" width="500px" :title="isEdit ? '编辑' : '新增'" @cancel="close" @ok="onOk">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
        <a-form-model-item label="ID" prop="value">
          <a-input-number v-model="form.value" placeholder="请输入ID" />
        </a-form-model-item>
        <a-form-model-item label="名称" prop="label">
          <a-input v-model="form.label" placeholder="请输入名称" />
        </a-form-model-item>
        <a-form-model-item label="颜色" prop="color">
          <a-input v-model="form.color" placeholder="请输入颜色" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>

export default {
  components: { },
  props: {
    selectedKey: {
      type: String,
      default: ''
    },
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      form: { 'label': '名称', 'value': 100, 'color': 'cyan' },
      rules: {
        label: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      },
      modalVisible: false,
      loading: false,
      title: '新增',
      isEdit: false
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    close() {
      this.modalVisible = false;
      this.form = { 'label': '', 'value': 100, 'color': 'cyan' };
    },
    open(_isEdit) {
      this.isEdit = _isEdit;
      this.form = { 'label': '', 'value': 100, 'color': 'cyan' };
      this.modalVisible = true;
    },
    onOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const orgList = JSON.parse(JSON.stringify(this.dataList));
          const u = orgList.find(item => item.value === this.form.value);
          if (u) {
            Object.assign(u, this.form);
          } else {
            orgList.push(this.form);
          }
          console.log('orgList', orgList);
          this.$emit('ok');
          this.close();
        }
      });
    }

  }
};
</script>

